export default __webpack_public_path__ + "static/media/4.7c3b0d4c.png";